import { IconProps } from "./types";

const ClosedEye = ({ ...props }: IconProps) => {
    return (
        <svg width="20" height="8" viewBox="0 0 20 8" fill="none" {...props}>
            <path
                d="M1.66602 1.06348C1.66602 1.06348 4.58268 4.39681 9.99935 4.39681C15.416 4.39681 18.3327 1.06348 18.3327 1.06348M3.33268 2.43431L1.66602 4.39681M18.3327 4.39681L16.6694 2.43681M7.42768 4.13014L6.66602 6.48014M12.5519 4.13681L13.3327 6.48014"
                stroke="#100069"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ClosedEye;
